{
    "table_header__product_name": "Artikel",
    "table_header__line_status": "Status",
    "table_header__quantity_ordered": "Menge",
    "table_header__rebate": "Rabatt",
    "table_header__price": "Preis",
    "table_header__total": "Summe",
    "table_header__gross_margin": "DB",
    "table_header__gross_margin_percentage": "DB %",
    "table_header__encrypted_purchase_price": "Warenschlüssel"
}
